import React from 'react';

export const P = ({ children, className, ...props }) => (<p className={`content ${className || ''}`} {...props}>{children}</p>);
